import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { backendApi } from "../../api/apiService";
import noData from "../../images/noData.png";
import { FaMoneyBillWave } from "react-icons/fa";
import { MdViewTimeline } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { FaLocationDot } from "react-icons/fa6";
import {
  FaAddressBook,
  FaAward,
  FaClock,
  FaEnvelope,
  FaEdit,
  FaMobile,
  FaSearchLocation,
} from "react-icons/fa";
import ShortListPopup from "./shortListPopup";
import ScheduleInterviewPopup from "../schedule/scheduleInterviewPopup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsArrowLeftCircleFill } from "react-icons/bs";

function ViewMatching() {
  const navigate = useNavigate();
  const location = useLocation();
  console.log("loc", location.state);
  const [resumes, setResumes] = useState([]);
  const [showShortList, setShowShortList] = useState(false);
  const [candidateId, setCandidateId] = useState("");
  const [candidate, setCandidate] = useState(null);
  const [scheduleInterview, setScheduleInterview] = useState(false);
  const [opening, setOpening] = useState({});

  useEffect(() => {
    setTimeout(() => {
      document.getElementById("NewVacancyMenu").classList.add("active");
    }, 500);
    viewResumesInit();
    getJobOpening(location.state.props.id);
  }, []);

  const candidateInterview = (id) => {
    setCandidateId(id);
    setScheduleInterview(true);
    setOpening(candidate);
  };

  const Cancel = () => {
    setShowShortList(false);
  };

  const goToEditPage = (candidateId) => {
    navigate(`/candidateprofile/${candidateId}`, { state: { from: 'viewmatch' } });
  };
  

  const getJobOpening = (jobId) => {
    var req = {
      functionName: "getJobOpeningDetailsById",
      job_opening_id: jobId.id ? jobId.id : jobId,
      site_id: localStorage.getItem("siteId"),
    };
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success == 1) {
        console.log("res", response);
        setCandidate(response.JobOpeningData[0]);
      } else {
        console.log("error");
        return false;
      }
    });
  };

  const handleSave = (jobId) => {
    var req = {
      functionName: "saveShortList",
      sec_user_id: localStorage.getItem("userId"),
      candidate_id: jobId,
      job_opening_id: candidate.id,
      remarks: "",
      site_id: localStorage.getItem("siteId"),
    };

    console.log("req", req);
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success == "1") {
        toast.success("Candidate ShortListed !", { containerId: "D" });
      } else {
        console.log("error in api");
        return false;
      }
    });
  };

  const closePopup = () => {
    setScheduleInterview(false);
  };

  const showShortListClick = (id) => {
    setCandidateId(id);
    setShowShortList(true);
  };

  const viewResumesInit = () => {
    var req = {
      functionName: "viewMachingResume",
      site_id: localStorage.getItem("siteId"),
      job_opening_id: location.state.props.id,
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success == "1") {
        setResumes(response.resumes);
      } else {
        console.log("error in api");
        return false;
      }
    });
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  function formatDateToCustomFormat(dateString) {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };

    return new Date(dateString).toLocaleDateString("en-GB", options);
  }
  const handleBack = () => {
    navigate('/schedule/createJobOpening');
  };
  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        <LeftMenu />
        <div className="content-wrapper">
          <Header Header="Matching Resumes" />
          <div className="main-container">
            <div className="card main-card">
              <div className="card-body">
                <ToastContainer
                  enableMultiContainer
                  containerId={"D"}
                  position="bottom-right"
                  autoClose={1500}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="colored"
                />
                <div className="xilliWrap">
                  <div className="row">
                    {/* <div className="col-md-12 xilliBrudcrb">
                  <h1 className="pb-0">Matching Resumes</h1>
                </div> */}
                    <div className="col-md-12">
                      {candidate && (
                        <div className="processDivTop mb-4">
                          <div className="processItem w-100 mb-1">
                            <span className="processHead text-secondary">Summary : </span>
                            <span className="processContent">
                              <b>{candidate.summary}</b>
                            </span>
                          </div>
                          <div className="processItem w-100 mb-1">
                            <span className="processHead text-secondary">Description : </span>
                            <span className="processContent">
                              {candidate.description}
                            </span>
                          </div>
                          <div className="processItem mb-1">
                            <span className="processHead text-secondary">Status : </span>
                            <span className="processContent">
                              {candidate.status}
                            </span>
                          </div>
                          <div className="processItem mb-1">
                            <span className="processHead text-secondary">Priority : </span>
                            <span className="processContent">
                              {candidate.priority}
                            </span>
                          </div>
                          <div className="processItem mb-1">
                            <span className="processHead text-secondary">Experience : </span>
                            <span className="processContent">
                              {candidate.experiance} Years
                            </span>
                          </div>
                          <div className="processItem mb-1">
                            <span className="processHead text-secondary">Location : </span>
                            <span className="processContent">
                              {candidate.location}
                            </span>
                          </div>
                          <div className="processItem mb-1">
                            <span className="processHead text-secondary">Salary : </span>
                            <span className="processContent">
                              {candidate.salary ? candidate.salary : "NA"}
                            </span>
                          </div>
                          <div className="processItem">
                            <span className="processHead text-secondary">Posted On :</span>
                            <span className="processContent">
                              {" "}
                              {formatDateToCustomFormat(candidate.created_on)}
                            </span>
                          </div>
                          <div className="processItem">
                            <span className="processHead text-secondary">No of positions : </span>
                            <span className="processContent">
                              {candidate.no_of_position}
                            </span>
                          </div>
                          <div className="processItem">
                            <span className="processHead text-secondary">Start Date : </span>
                            <span className="processContent">
                              {formatDate(candidate.start_date)}
                            </span>
                          </div>
                          <div className="processItem">
                            <span className="processHead text-secondary">Job Type : </span>
                            <span className="processContent">
                              {candidate.job_type}
                            </span>
                          </div>
                        </div>
                      )}
                      <div className="table-scroll table-responsive">
                        {resumes.length != 0 && (
                          <table className="table">
                            <thead style={{ height: "30px" }}>
                              <tr>
                                <th style={{ width: "100px" }}>#</th>
                                <th style={{ textAlign: "left", width: "100px" }}>
                                  Candidate Details
                                </th>
                                <th style={{ textAlign: "left", width: "650px" }}>
                                  Skill Set
                                </th>
                                <th style={{ textAlign: "left", width: "100px" }}>
                                  Experience
                                </th>
                                <th style={{ textAlign: "center", width: "50px" }}>
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            {resumes?.map((resume, index) => {
                              return (
                                <tbody>
                                  <tr>
                                    <td aria-label="Lead Summary">{index + 1}</td>
                                    <td aria-label="Lead Summary">
                                      <p className="mx-0 mb-1 lead-name" >
                                        {resume.full_name}
                                      </p>
                                      <p className="mx-0 mb-1 d-flex">
                                        <span className="svg-icon-span">
                                          <FaAddressBook
                                            title="address"
                                            size={12}
                                          />
                                        </span>
                                        <span
                                          style={{ width: "80%", marginLeft: "2%" }}
                                        >
                                          {resume.address ? resume.address : "NA"}
                                        </span>
                                      </p>
                                      <p className="mx-0 mb-1 d-flex">
                                        <span className="svg-icon-span">
                                          <FaEnvelope title="email" size={12} />
                                        </span>
                                        <span
                                          style={{ width: "80%", marginLeft: "2%" }}
                                        >
                                          {resume.email_id ? resume.email_id : "NA"}
                                        </span>
                                      </p>
                                      <p className="mx-0 mb-1 d-flex">
                                        <span className="svg-icon-span">
                                          <FaMobile title="Contact No:" size={12} />
                                        </span>
                                        <span
                                          style={{ width: "80%", marginLeft: "2%" }}
                                        >
                                          {resume.mobile_no
                                            ? resume.mobile_no
                                            : "NA"}
                                        </span>
                                      </p>
                                      <p className="mx-0 mb-1 d-flex">
                                        <span className="svg-icon-span">
                                          <FaSearchLocation
                                            title="Region"
                                            size={12}
                                          />
                                        </span>
                                        <span
                                          className="row"
                                          style={{ width: "80%", marginLeft: "2%" }}
                                        >
                                          {resume.location ? resume.location : "NA"}
                                        </span>
                                      </p>
                                      <p className="mx-0 mb-1 d-flex">
                                        <span className="svg-icon-span">
                                          <FaClock title="Uploaded On" size={12} />
                                        </span>
                                        <span
                                          className="row"
                                          style={{ width: "80%", marginLeft: "2%" }}
                                        >
                                          {formatDateToCustomFormat(
                                            resume.created_on
                                          )}
                                        </span>
                                      </p>
                                    </td>
                                    <td
                                      aria-label="Skills"
                                      style={{ textAlign: "left" }}
                                    >
                                      <div className="mx-0 mb-1 lead-name"
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          flexWrap: "wrap"
                                        }}>
                                        {resume.skill_name ? (
                                          resume.skill_name
                                            .split(",")
                                            .map((loc, i) => (
                                              <span
                                                key={i}
                                                style={{
                                                  fontSize: 10.5,
                                                  backgroundColor: "#fdf498",
                                                  borderRadius: "5px",
                                                  margin: "0 5px 5px 0",
                                                  padding: "2px 5px",
                                                  color: "#000",
                                                }}
                                              >
                                                {loc.trim()}
                                              </span>
                                            ))
                                        ) : (
                                          <span style={{ fontSize: 12 }}>
                                            NA
                                          </span>
                                        )}
                                      </div>
                                    </td>
                                    <td>
                                      <p className="mx-0 mb-1 lead-name">
                                        <FaAward title="experience" />{" "}
                                        {resume.total_experiance}
                                      </p>
                                      <p className="mx-0 mb-1 d-flex">
                                        <span className="svg-icon-span">
                                          <FaMoneyBillWave title="CTC" size={12} />
                                        </span>
                                        <span
                                          style={{ width: "80%", marginLeft: "2%" }}
                                        >
                                          {resume.ctc ? resume.ctc : "NA"}
                                        </span>
                                      </p>
                                      <p className="mx-0 mb-1 d-flex">
                                        <span className="svg-icon-span">
                                          <MdViewTimeline
                                            title="Notice Period"
                                            size={12}
                                          />
                                        </span>
                                        <span
                                          style={{ width: "80%", marginLeft: "2%" }}
                                        >
                                          {resume.notice_period
                                            ? resume.notice_period
                                            : "NA"}
                                        </span>
                                      </p>
                                      <p className="mx-0 mb-1 d-flex">
                                        <span className="svg-icon-span">
                                          <FaLocationDot
                                            title="Preferred Location"
                                            size={12}
                                          />
                                        </span>
                                        <span
                                          style={{ width: "80%", marginLeft: "2%" }}
                                        >
                                          {resume.preferredLocation
                                            ? resume.preferredLocation
                                            : "NA"}
                                        </span>
                                      </p>
                                    </td>
                                    <td
                                      aria-label="View"
                                      style={{ textAlign: "center" }}
                                    >
                                      <div className="mt-1">
                                        <button
                                          className="btn btn-btn1 btn-btn bg-secondary w-100 "
                                          onClick={() => goToEditPage(resume.id)}
                                        >
                                          Edit
                                        </button>
                                      </div>
                                      <div className="mt-1">
                                        <button
                                          className="btn btn-btn1 btn-btn bg-primary w-100 "
                                          onClick={() => {
                                            showShortListClick(resume.id)
                                          }}
                                        >
                                          ShortList
                                        </button>
                                      </div>
                                      <div className="mt-1">
                                        <button
                                          className="btn btn-btn1 btn-btn bg-warning w-100 "
                                          onClick={() =>
                                            candidateInterview(resume.id)
                                          }
                                        >
                                          Schedule
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              );
                            })}
                          </table>
                        )}
                      </div>
                    </div>
                    {resumes.length == 0 && (
                      <span className="noData">
                        <p>
                          <img src={noData} />
                        </p>
                        <p> No Matching Resumes available</p>
                      </span>
                    )}
                  </div>
                  {showShortList && (
                    <ShortListPopup
                      Cancel={Cancel}
                      candidateId={candidateId}
                      jobId={location.state.props.id}
                    />
                  )}
                  {scheduleInterview && (
                    <ScheduleInterviewPopup
                      onClose={closePopup}
                      candidateId={candidateId}
                      opening={opening}
                    />
                  )}
                </div>
              </div>
            </div>
            <button
              type="button"
              className="floating-back-button"
              onClick={handleBack}
            >
              <BsArrowLeftCircleFill size={24}/>
            </button>
          </div>
        </div>
      </ div>
    </>
  );
}

export default ViewMatching;
